export default function LoadingFallback() {
  return (
    <div className="flex items-center justify-center py-24">
      <span className="text-sm text-muted font-mono animate-pulse">
        [ LOADING ] Initializing module...
      </span>
    </div>
  );
}
